<template>
<div v-if="LoginAlertBox && LoginAlertBox.showAlertBox" class="alert-box">
    <div class="alert-icon">
        <!-- <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 20h20L12 2z" stroke="#1E1E1E" stroke-width="2" fill="none"/>
            <circle cx="12" cy="17" r="1.5" fill="#1E1E1E"/>
            <path d="M12 9v5" stroke="#1E1E1E" stroke-width="2"/>
        </svg> -->
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="#1E1E1E" stroke-width="2" fill="none"/>
        <path d="M7 12.5l3 3 7-7"
                stroke="#1E1E1E"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
    </div>
    <div class="alert-content">
        <h3>{{ LoginAlertBox.title }}</h3>
        <div v-html="LoginAlertBox.messageHTML"></div>
    </div>
</div>


<div v-if="loadingAuth" class="loading-skeleton-container">
    <div class="loading-skeleton">
        <loading-skeleton :loadingHeight="'400px'" />
    </div>
</div>
<div class="amplify-container">
    <amplify-authenticator>
        <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
        <amplify-sign-in slot="sign-in"
            header-text="Sign in to create a shipment."
            hideSignUp
        ></amplify-sign-in>


        <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
        <amplify-sign-up slot="sign-up"
                v-if="authState === 'signup'"
                headerText="Sign up to create a shipment."
                :formFields="formFields"
        ></amplify-sign-up>
            
    </amplify-authenticator>
</div>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
/**
 * AWS Amplify Login Page
 */
import { Auth } from 'aws-amplify';
// import { Hub } from "aws-amplify";
import {onAuthUIStateChange} from "@aws-amplify/ui-components";
import LoadingSkeleton from '../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../Popups/AlertUser.vue'
import axios from 'axios'

export default {
    data(){
        return{
            loadingAuth: false,
            toggleAlertBox: '',
            LoginAlertBox: {},
            alertMessage: 'To pay your invoice, please sign in to the new platform. If you haven’t signed in before, use your current login credentials and you’ll be guided through the steps to set up your account. Once signed in, go to the left menu and select Customer Billing to view and pay invoices, or Payment Settings to manage your payment details.'
        }
    },
    components:{
        LoadingSkeleton,
        AlertUser
    },
    methods:{
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async getLoginAlertBox(){
            await axios.get('https://lrexsite-bucket155400-prod.s3.us-east-1.amazonaws.com/public/LoginAlertBox.json').then((response)=>{
              this.LoginAlertBox = response.data;
            })
        }
    },
/**
 * Using amplify Hub listen for signIn
 * If 'signIn' push user to shipping page
 */
    mounted(){
        const payInvoice = this.$route.query.payinvoice;
        if (payInvoice === "true") {
            this.toggleAlertBox = true;
        }
        // Hub.listen('auth', (data) => {
        //     this.loadingAuth = true
        //     console.log("HUB: ", data.payload.event)
        //     switch (data.payload.event) {
        //         case 'signIn':
        //             this.$router.push('ShipmentDashboard')
        //             break;
        //         case 'verifyContact':
        //             this.$router.push('Login')
        //             break;
        //         case 'signedin':
        //             this.$router.push('ShipmentDashboard')
        //             break;
        //         }
        // });

        onAuthUIStateChange(async (nextAuthState, authData) => {
            this.loadingAuth = true
            if(nextAuthState === 'verifyContact'){
                this.$router.push('Login')
            }

            if(nextAuthState === 'signedin'){
                if(authData){
                    console.log(authData)
                    if(authData.signInUserSession.idToken.payload['cognito:groups']){
                        if(authData.signInUserSession.idToken.payload['cognito:groups'].includes('Admin')){
                            this.$router.push('AdminShipmentDashboard')
                            return;
                        }

                        if(authData.signInUserSession.idToken.payload['cognito:groups'].includes('InternalAdmin')){
                            this.$router.push('AdminShipmentDashboard')
                            return;
                        }

                        if(authData.signInUserSession.idToken.payload['cognito:groups'].includes('CustomerAdmin')){
                            this.$router.push('CustomerAdminShipmentDashboard')
                            return;
                        }

                        if(authData.signInUserSession.idToken.payload['cognito:groups'].includes('Customer')){
                            this.$router.push('ShipmentDashboard')
                            return;
                        }
                    }else{
                        this.$router.push('ShipmentDashboard')
                    }
                }else{
                    this.$router.push('ShipmentDashboard')
                }
            }
            this.loadingAuth = false
        });

        this.getLoginAlertBox();
    },
/**
 * Before Login page is loaded check if user is already signed in
 * Fixes issue when user trys to go back to login page
 */
    beforeMount(){
        //Check if user is signed in before loading page.
        Auth.currentSession()
        .then(data => {
            //User is logged in
            if(data){
                this.$router.push('ShipmentDashboard');
            }
        })
        .catch(err => {
            //User is not logged in
            if(err){
                Auth.signOut({global: false});
            }
        });
    }
}
</script>

<style scoped>
/* Amplify Authenticator */
    .amplify-container{
        /* margin-top: -180px; */
        margin-top: 10px;
    }

    .loading-skeleton-container{
        display: flex;
        justify-content: center;
        margin-bottom: 200px;
    }

    .loading-skeleton{
        width: 50%;
    }

    .alert-box {
        width: 100%;
        padding: 1.2rem 1.5rem;
        background-color: #33f18a;
        border-radius: 0.75rem;
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        margin: 1.5rem auto;
        margin-bottom: 0;
        box-shadow: 0 0.6rem 1.2rem rgba(0, 0, 0, 0.15);
        font-family: Arial, sans-serif;

        /* make it centered and scalable */
        max-width: 50%;
    }

    /* icon */
    .alert-icon svg {
        width: 1.75rem;
        height: 1.75rem;
        flex-shrink: 0;
    }

    /* heading */
    .alert-content h3 {
        margin: 0;
        font-size: 1.2rem;
        font-weight: 700;
        color: #1E1E1E;
    }

    /* paragraph text */
    .alert-content p {
        margin-top: 0.5rem;
        font-size: 1rem;
        color: #1E1E1E;
        line-height: 1.45;
    }

    /* ---------- Responsive tweaks for small screens ---------- */
    @media (max-width: 1000px) {
        .alert-box {
            flex-direction: column;
            text-align: left;
        }

        .alert-icon svg {
            width: 2rem;
            height: 2rem;
        }

        .alert-box {
            max-width: 80%;
        }
    }


    amplify-authenticator{
        --width: 450px;
        --height: 600px;
        --amplify-primary-color: #32ccfe;
        --amplify-secondary-tint: #2cb6e4;
        --amplify-primary-shade: #32ccfe;
        --amplify-primary-tint: #32ccfe;
        --container-height: fit-content;
    }
</style>